// extracted by mini-css-extract-plugin
module.exports = {"root":"FieldCheckboxGroup_root__RFvjG","list":"FieldCheckboxGroup_list__PmD_Q","twoColumns":"FieldCheckboxGroup_twoColumns__HP1Wb","item":"FieldCheckboxGroup_item__2HRmq"};